// The product paths of decision 3 and where each sends people until its product moves in, as plain
// data and helpers that read no build setting, so a test can import them (tests/e2e/library.spec.js,
// the portal cards). config/products.js re-exports all of it beside the redirects, which read the
// build's HUB_NOT_MOVED_IN; the app imports it from there.

export const PRODUCT_PATHS = [
  {
    path: '/masterclass', door: 'masterclass', type: 'masterclass', look: 'poyt',
    name: 'Buy your next property without a deposit',
    // the watch page link can be forwarded, so it's never a destination: the Library instead
    notMovedIn: '/',
  },
  {
    path: '/funding-engine', door: 'fe', type: 'live_cohort', look: 'funding_engine',
    name: 'The Funding Engine',
    // to the Library until stage 10
    notMovedIn: '/',
  },
  {
    path: '/poyt', door: 'poyt', type: 'live_cohort', look: 'poyt',
    name: 'Profit On Your Terms',
    notMovedIn: 'https://course.adamslee.co.uk',
  },
  {
    path: '/cashflow', door: 'cashflow', type: 'on_demand', look: 'accelerator',
    name: 'Property Cashflow For Life',
    // waits for its launch: nothing of its own until then, so the Library
    notMovedIn: '/',
  },
  {
    path: '/accelerator', door: 'acc', type: 'mastermind', look: 'accelerator',
    name: 'The Property Accelerator',
    notMovedIn: 'https://members.adamslee.co.uk',
  },
]

// '/funding-engine/week-3' -> '/funding-engine'
export function basePath(path) {
  const first = path.split('/').filter(Boolean)[0]
  return first ? '/' + first : '/'
}

export function productPathConfig(path) {
  const base = basePath(path)
  return PRODUCT_PATHS.find(p => p.path === base) || null
}

// The site a product still lives on until it moves in (its https notMovedIn address), or null when
// it has none: the Library's portal cards link out to it (Adam, 10 Oct), so the address stays here.
export function siteFor(path) {
  const p = path ? productPathConfig(path) : null
  return p && /^https:\/\/[^/]+$/.test(p.notMovedIn) ? p.notMovedIn : null
}

// Products are known by name in a few places where only the name and look reach the browser (a
// webinar's call to action names what it sells, which a non-owner can't read from the catalogue).
export function productTypeByName(name) {
  const p = PRODUCT_PATHS.find(x => x.name === name)
  return p ? p.type : null
}
